import { css } from '@lastbrand/web-ui-styled-system/css'

// DS twins of `product-details-icon-v2.module.scss` (the concluded V2 design). The legacy
// module authors sizes in rem at the ~10px fluid root, which balloons 1.6x under the DS
// 16px root; these classes restate the intended px values with DS tokens.

// Chip container (legacy `.icons`).
export const chipDsClass = css({
  borderRadius: 'radius-sm',
  backgroundColor: 'offwhite',
  display: 'flex',
  padding: 'space-8',
  flexDirection: 'row',
  alignItems: 'center',
  gap: 'space-8',
  flexShrink: 0,
})

export const iconWrapperDsClass = css({
  width: '30px',
  height: '30px',
  maxWidth: '30px',
  maxHeight: '30px',
  lgDown: { width: '24px', height: '24px' },
})

export const iconTextDsClass = css({
  textStyle: 'body-12',
  fontWeight: 500,
  textTransform: 'none',
})

// Scrollable chips row (legacy `productDetailsAndCareV2__iconsContainer`) with a
// right-edge fade that vanishes once scrolled.
export const chipsRowDsClass = css({
  display: 'flex',
  paddingTop: 'space-4',
  paddingBottom: 'space-20',
  alignItems: 'center',
  alignContent: 'center',
  gap: 'space-12',
  alignSelf: 'stretch',
  overflowX: 'auto',
  scrollbarWidth: 'none',
  '&::-webkit-scrollbar': { display: 'none' },
  _after: {
    content: '""',
    position: 'absolute',
    right: { base: '0', lg: '75px' },
    width: '60px',
    height: '44px',
    background: 'linear-gradient(90deg, rgb(255 255 255 / 0%) 0%, #fff 30.85%)',
  },
})

// Toggled by scroll (same contract as legacy `.noFade`); `!` so it beats the base `_after`.
export const chipsRowNoFadeDsClass = css({
  _after: { display: 'none!' },
})
